import { Navigate, NavLink, Outlet, useLocation } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { useAuth } from '../../../context/AuthContext'
import { ADMIN_FORM_MODULES } from '../../../constants/adminModules'
import { ADMIN_DASHBOARD_PATH, adminPath } from '../../../constants/adminRoutes'

export default function AdminFormsLayout() {
  const { t } = useTranslation()
  const { hasModuleAccess } = useAuth()
  const location = useLocation()

  const visibleNav = ADMIN_FORM_MODULES.filter(({ key }) => hasModuleAccess(key))
  const isIndex =
    location.pathname === '/cp-login/forms' || location.pathname === '/cp-login/forms/'

  if (!visibleNav.length) {
    return <Navigate to={ADMIN_DASHBOARD_PATH} replace />
  }

  return (
    <div className="mx-auto max-w-6xl">
      <div className="mb-6">
        <h1 className="text-2xl font-bold text-primary">{t('admin.forms.title')}</h1>
        <p className="mt-1 text-sm text-text/60">
          {isIndex ? t('admin.forms.indexSubtitle') : t('admin.forms.subtitle')}
        </p>
      </div>

      {!isIndex && visibleNav.length > 0 ? (
        <nav className="mb-6 flex flex-wrap gap-2 border-b border-border pb-4">
          <NavLink
            to="/cp-login/forms"
            end
            className={({ isActive }) =>
              `rounded-xl px-4 py-2 text-sm font-medium transition-colors ${
                isActive ? 'bg-primary text-white' : 'bg-primary/5 text-primary hover:bg-primary/10'
              }`
            }
          >
            {t('admin.forms.all')}
          </NavLink>
          {visibleNav.map(({ route, labelKey }) => (
            <NavLink
              key={route}
              to={`/cp-login/forms/${route}`}
              className={({ isActive }) =>
                `rounded-xl px-4 py-2 text-sm font-medium transition-colors ${
                  isActive ? 'bg-primary text-white' : 'bg-primary/5 text-primary hover:bg-primary/10'
                }`
              }
            >
              {t(labelKey)}
            </NavLink>
          ))}
        </nav>
      ) : null}

      <Outlet />
    </div>
  )
}
